<div class="item-group">
	@if (isPlainStringHtml()) {
		<span [innerHTML]="plainHtmlString | safeHtml"></span>
	} @else if (tabs.length > 0) {
		<tec-tabs [tabs]="tabs" type="pills" (tabSelected)="onTabSelected($event)" />
		<span [innerHTML]="selectedObjectHtml | safeHtml"></span>
	}
</div>
